import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormControl, Validators} from '@angular/forms';
import {ThemePalette} from '@angular/material/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Store} from '@ngxs/store';
import {SetPaymentStepOtt} from '../../shared/map.actions';
import {MobicredService} from 'src/app/services/mobicred/mobicred.service';
import {InitializePaymentResponse} from 'src/app/interfaces/mobicred/InitializePaymentResponse';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Session} from 'src/app/interfaces/session-data';
import {HttpErrorResponse} from '@angular/common/http';
import {DirtyErrorStateMatcherDirective} from 'src/app/directives/dirty-error-state-matcher.directive';
import {GoogleAnalyticsService} from '../../../services/google-analytics/google-analytics.service';
import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';
import {PaymentMethodsOther} from '../../../interfaces/payment-methods';
import {Observable} from 'rxjs';

@Component({
  selector: 'app-mobicred-otp',
  templateUrl: './mobicred-otp.component.html',
  styleUrls: ['./mobicred-otp.component.scss']
})
export class MobicredOtpComponent implements OnInit {

  public password: string;
  public paymentOptionsLoadedJustify = 'space-between !important';
  public diameter = 50;
  public otpSpinnerDiameter = 40;
  public color: ThemePalette = 'primary';
  public otp = new FormControl('', [Validators.required, Validators.pattern('[0-9]*')]);
  matcher = new DirtyErrorStateMatcherDirective();
  otpLoading = false;
  public headerColor = '';
  showErrors = true;
  // @Input('timeRemaining') timeRemaining: number;
  timeRemaining = 1800;
  secondCountdown = Math.floor(this.timeRemaining / 60) === 0 ? this.timeRemaining : 30 ;
  timeRemainingInterval;
  // loading var
  public loading = false;
  public otpSubmitted = false;
  mobile;
  initializePaymentResponse: InitializePaymentResponse;

  session: Session;

  // UX Friendly string time builder
  uxFriendlyTime(time: number) {
    return `${Math.floor(time / 60)}:${this.secondCountdown.toString().length <= 1 ? '0' + this.secondCountdown.toString() : this.secondCountdown.toString()}`;
  }

  get otpControl() {
    return this.otp;
  }

  constructor(private router: Router, private route: ActivatedRoute, private store: Store, private mobicredSerivce: MobicredService, private _snackBar: MatSnackBar, private googleAnalyticsService: GoogleAnalyticsService, private breakpointObserver: BreakpointObserver) {
    this.store.dispatch(new SetPaymentStepOtt('STEP_TWO'));

    breakpointObserver.observe([
      Breakpoints.HandsetLandscape,
      Breakpoints.HandsetPortrait
    ]).subscribe(result => {
      this.mobile = result.matches;
    });

    this.timeRemainingInterval = setInterval(() => {
      if (this.timeRemaining === 0) {
        clearInterval(this.timeRemainingInterval);
        this.router.navigate(['transaction-status']);
      }
      // Decrement time remaining in 1s intervals
      this.timeRemaining -= 1;
      // Change e.g 4:00 next count to 3:59 and don't decrement afterwards,
      // I suppose it could be changed to 60 and decremented but ¯\_(ツ)_/¯
      if (this.secondCountdown === 0) {
        this.secondCountdown = 59;
      } else {
        this.secondCountdown -= 1;
      }
    }, 1000);
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 5000,
    });
  }

  cancelTransaction() {
    this.router.navigate(['transaction-status/userCancelled']);
  }

  resetValidation() {
    sessionStorage.setItem('formSubmitted', 'false');
  }

  ngOnInit(): void {
    sessionStorage.setItem('formSubmitted', 'false');
    this.session = (JSON.parse(sessionStorage.getItem('sessionData')) as Session);
    this.headerColor = (document.getElementsByClassName('header-container')[0] as HTMLElement).style.backgroundColor;

    this.initializePaymentResponse = JSON.parse(sessionStorage.getItem('mobicred-data'));

  }

  getErrorMessage() {
    if (this.otp.hasError('required')) {
      return 'You must enter a value';
    }

    if (this.otp.hasError('pattern')) {
      return 'OTP may only be numbers';
    }

  }

  enteredOTP(){
    if (!this.otp.hasError('required') && !this.otp.hasError('pattern')) {
      this.otpSubmitted = true;
      this.loading = true;
      this.mobicredSerivce.validateTransaction(sessionStorage.getItem('sessionToken'), this.otp.value).subscribe((data ) => {
        this.loading = false;
        // TODO: Handle OTP Error, seems to return 200 for everything with no body, this is due to the product & platform layer error-handling being a WIP
        this.router.navigate(['transaction-status']);
      }, (err: HttpErrorResponse) => {
        sessionStorage.setItem('formSubmitted', 'true');
        this.loading = false;
        this.otpSubmitted = false;

        const parsedError = JSON.parse(err.error.errorItems[0].message).errorItems[0].message.toLowerCase();
        if (parsedError.toLowerCase().indexOf('account required verification') > -1) {
          this.router.navigate([`transaction-status`]);
        } else {
          if (err.status === 400) {
            this.openSnackBar('Invalid OTP entered', 'Please Try Again');
          } else {
            this.router.navigate([`transaction-status`]);
          }
        }


      });
    } else {
      this.otp.markAsTouched({onlySelf: true});
      this.otp.setValue('');
      return this.getErrorMessage();
    }
  }

  resendOTP(){
    this.otpLoading = true;
    this.mobicredSerivce.requestOtp(sessionStorage.getItem('sessionToken')).subscribe((data: any) => {
      this.otpLoading = false;
    }, (err: HttpErrorResponse) => {
      this.loading = false;
      this.otpSubmitted = false;
      this.router.navigate([`transaction-status`]);
    });
  }

}
